var _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTerrain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eoQKVuyA8rS1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 400 500",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "eoQKVuyA8rS2",
    width: 51,
    height: 236,
    rx: 0,
    ry: 0,
    transform: "matrix(-1 0 0-1 70.5 249.781822)",
    fill: "#1d1d1b"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "eoQKVuyA8rS3",
    width: 51,
    height: 180,
    rx: 0,
    ry: 0,
    transform: "matrix(-1 0 0-1 132.5 193.781822)",
    fill: "#1d1d1b"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "eoQKVuyA8rS4",
    width: 51,
    height: 140,
    rx: 0,
    ry: 0,
    transform: "matrix(-1 0 0-1 194.5 153.781822)",
    fill: "#1d1d1b"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "eoQKVuyA8rS5",
    width: 51,
    height: 180,
    rx: 0,
    ry: 0,
    transform: "matrix(-1 0 0-1 256.5 193.781822)",
    fill: "#1d1d1b"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "eoQKVuyA8rS6",
    width: 51,
    height: 234.656542,
    rx: 0,
    ry: 0,
    transform: "matrix(-1 0 0-1 317.006876 249.781822)",
    fill: "#1d1d1b"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "eoQKVuyA8rS7",
    width: 51,
    height: 272.44,
    rx: 0,
    ry: 0,
    transform: "matrix(-1 0 0-1 380 287.56528)",
    fill: "#1d1d1b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerrain);
export default __webpack_public_path__ + "static/media/Terrain.4e30c83efa762480e862f744ebe4f5c2.svg";
export { ForwardRef as ReactComponent };